import { createRoot } from "react-dom/client";
import App from "./components/App";
import "./index.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { RootLayout } from "./components/root";
import { environment, internalVersion, segmentWriteKey } from "./utils/constants";
const url = window.location.href;
console.log(internalVersion);

import { AnalyticsBrowser } from "@segment/analytics-next";
export const analytics = AnalyticsBrowser.load({ writeKey: segmentWriteKey[environment] });

/* global document, Office, module, require */

const rootElement: HTMLElement = document.getElementById("container")!;
const root = createRoot(rootElement);

const IndexPage = () => {
  return <App />;
};

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "/", element: <IndexPage /> },
      { path: "/taskpane.html", element: <IndexPage /> },
      { path: "/sign-in", element: <IndexPage /> },
    ],
  },
]);

/* Render application after Office initializes */
Office.onReady(() => {
  root.render(<RouterProvider router={router} />);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root.render(NextApp);
  });
}
